import DataAccess from "@/Services/DataAccess";

const state = {
  verifactuActivo: false,
  configuracio: {
    urlServei: '',
    entorn: 'desenvolupament',
    nifEmpresa: '',
    nomEmpresa: ''
  }
};

const mutations = {
  SET_VERIFACTU_ACTIVO(state, valor) {
    state.verifactuActivo = valor;
  },
  SET_CONFIGURACIO(state, configuracio) {
    state.configuracio = configuracio;
  }
};

const actions = {
  async guardarConfiguracio({ state }) {
    // Guardar en el servidor usando el estado actual del store
    const response = await DataAccess.putData('/api/configuration/verifactu', null, state.verifactuActivo
    //   configuracio: state.configuracio
    );
    return response;
  },

  async cargarConfiguracio({ commit }) {
    const response = await DataAccess.getData('/api/configuration');
    commit('SET_VERIFACTU_ACTIVO', response.data.verifactu);
    // commit('SET_CONFIGURACIO', response.data.configuracio);
    return response;
  }
};

const getters = {
  verifactuActivo: (state) => state.verifactuActivo,
  configuracio: (state) => state.configuracio
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
